import { render } from "./Quotation.vue?vue&type=template&id=6aad5bb2"
import script from "./Quotation.vue?vue&type=script&lang=js"
export * from "./Quotation.vue?vue&type=script&lang=js"

import "./Quotation.vue?vue&type=style&index=0&id=6aad5bb2&lang=css"

import exportComponent from "D:\\Code Backup\\ts-web-old\\TatSingGroup-Web\\ts-trading\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__